export const environment = {
  production: false,

  // API URL is now DYNAMIC via TenantService
  // Tenant identified via X-Tenant header on all requests
  // Set by: TenantService.apiBaseUrl (driven by select-instance page)
  //
  // v1.6.824 — Repointed to backend.happymealprep.com per operator
  // request. Old value was https://happymanagement.yourmealprep.com/api;
  // the host changed but the /api suffix is preserved — the OpenAPI
  // spec's `servers: [{"url": "/api"}]` confirms endpoints still live
  // under /api on the new host, so existing call sites that build
  // `${apiBaseUrl}/v1/tenant/...` keep working unchanged.
  api: {
    baseUrl: 'https://backend.happymealprep.com/api',
    timeout: 30000,
  },

  enableApiLogging: true,
};
